const Hero = () => {
  return (
    <div className="bg-[#E7F2F5] flex flex-col items-center justify-center h-[200px] md:h-[524px] text-[30px] md:text-[72px] text-hColor">
      <h1>Frequently asked questions</h1>
    </div>
  );
};

export default Hero;
